module.exports = __webpack_public_path__ + "BM.png?840a1f433d1cb0639dab7d7326bc5f53";